import React, { useCallback, useEffect, useState } from "react";
import { useRouter } from "next/router";
import { bookingType } from "../../services/data.js";
import styles from "../../styles/sass/search.module.scss";

const SelectResourceScreen = (props) => {
  const router = useRouter();

  const [slidepage, setSlidePage] = useState(false);

  useEffect(() => {
    setTimeout(() => setSlidePage(true), 500);
  }, []);

  const onClick = useCallback(
    (resource_type) => {
      if (resource_type) {
        props.onNext(`${router.asPath}&resource_type=${resource_type}`);
      }
    },
    [router.asPath, props.onNext]
  );

  return (
  <>
        <div className={`${styles["bk_o_cb"]} ${styles["srs_i"]}`}>
          <div
            className={`${styles["bk_i_cb"]} ${
              slidepage ? styles["bk_add_animation"] : ""
            }`}
          >
            <div className={`mc_container ${styles["bk_c_c_cb"]}`}>
              <div className={`${styles["bk_txt_cb"]} ${styles["pt50"]}`}>
                <h1 className={styles["title"]}>What are you looking for?</h1>
                <div className={styles["bk_item_cb"]}>
                  {bookingType.map((item) => {
                    const { id, name, url, price, img } = item;
                    const imageUrl = `/assets/images/${img}`;

                    return (
                      <div
                        key={id}
                        className={styles["bk_item"]}
                        onClick={() => {
                          if (price) {
                            onClick(url);
                          } else {
                            router.push("/book-a-visit")
                          }
                        }}
                      >
                        {/* <div className={`${styles["bk_item_inner"]} ${!price && "cursor-not-allowed"}`}> */}
                        <div className={styles["bk_item_inner"]}>
                          <div className={styles["bk_img"]}>
                            <img src={imageUrl} alt={name} />
                          </div>
                          <h4 className={styles["title"]}>
                            {name}
                            {id === "meeting-rooms" ? <span style={{ fontSize: "13px", display: "block" }}>(for existing tenants only) </span> : <span style={{ fontSize: "13px", display: "block" }}>&nbsp;</span>}
                          </h4>
                        </div>
                        {/* {
                          price
                          ? <span className={styles["price"]}>{price}</span>
                          : <span className={styles["price"]}>Soon to be available.</span>
                        } */}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
    </>
  );
};

export default SelectResourceScreen;
